// Client wrapper for the Worker's /api/cname-chain endpoint.

export type ChainHop = { name: string; target?: string };

export type CnameChain = {
  host: string;
  hops: ChainHop[];
  finalName: string;
  addresses: { a: string[]; aaaa: string[] };
  loop: boolean;
  truncated: boolean;
  findings: { level: "good" | "warn" | "info"; text: string }[];
};

export async function fetchCnameChain(host: string, signal?: AbortSignal): Promise<CnameChain> {
  const res = await fetch(`/api/cname-chain?host=${encodeURIComponent(host)}`, { signal });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error((body as any).error ?? `HTTP ${res.status}`);
  }
  return (await res.json()) as CnameChain;
}
